<template>
 <div class="color-testing">
   <div class="container" v-if="snapshotsMissing">
     <div class="color-testing__no-data">Awaiting Data</div>
   </div>
   <template v-else>
     <PieChart class="charts__pie"/>

     <AreaChart class="color-testing__chart"
                ref="chart"
                selectedType="msv"
                :cells="cells">
     </AreaChart>
   </template>
 </div>
</template>

<script>
import PieChart from '@/features/color-testing/PieChart'
import AreaChart from '@/features/color-testing/AreaChart'
import { mapState } from 'vuex'

export default {
  name: 'ColorTesting',
  components: {
    PieChart,
    AreaChart
  },
  data () {
    return {
      cells: [
        {
          label: '01 - 03',
          propName: '01 - 03'
        }, {
          label: '04 - 07',
          propName: '04 - 07'
        }, {
          label: '08 - 10',
          propName: '08 - 10'
        }, {
          label: '11 - 25',
          propName: '11 - 25'
        }, {
          label: '26 - 50',
          propName: '26 - 50',
          disabledByDefault: true
        }, {
          label: '51 - 100',
          propName: '51 - 100',
          disabledByDefault: true
        }, {
          label: 'NR',
          propName: 'NR',
          disabledByDefault: true
        }, {
          label: 'ND',
          propName: 'ND',
          disabledByDefault: true
        }
      ]
    }
  },
  computed: {
    ...mapState('rankZoneCommon', [
      'snapshots',
      'isSnapshotsLoaded'
    ]),
    snapshotsMissing () {
      return this.isSnapshotsLoaded && !this.snapshots.length
    }
  }
}
</script>

<style lang="scss" scoped>
  .color-testing {
    position: relative;
    padding: 40px 40px 0;
    display: flex;
    flex-direction: column;

    &__no-data {
      display: flex;
      height: 300px;
      background-color: #fff;
      border-radius: $rfx-default-border-radius;
      align-items: center;
      justify-content: center;
      font-size: 27px;
      font-weight: 600;
      color: $rfx-medium-grey;
    }

    &__chart {
      margin-top: 40px;
    }
  }
</style>
